import {PureComponent} from 'react'

import OffersExamples from './OffersExamples.jsx'

import './OffersExamples.scss'

export default class OffersExamplesEngineering extends PureComponent {
  render() {
    const title = "Finance : nos exemples de missions"
    const description = "Retrouvez les différents types de missions en Finance déjà postés sur notre plateforme : management de transition, interim management, groupe international, ETI, etc."

    return <OffersExamples
      helmet={{title, description}}
      universeCode="engineering"
      title="Les missions Ingénierie que vous auriez pu recevoir :"
    />
  }
}
